export function validatePassword(password) {
    let is_valid = true, error_message = "";
    const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

    if (password.length < 8) {
        is_valid = false
    }
    else if (!/\d/.test(password)) {
        is_valid = false
    }
    else if (!/[A-Z]/.test(password)) {
        is_valid = false
    }
    else if (!format.test(password)) {
        is_valid = false
    }
    console.log(is_valid)
    return is_valid;
}

export function validateEmail(email) {
    // var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    // if (email.match(validRegex)) {
     if (/^\w+([\.\+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)){
        // console.log("Valid email address!");
        return true

    } else {
        // console.log("Invalid email address!");
        return false
    }
    // const format =/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]$/;

    // console.log(format)
    // console.log(format.test(email))
    // console.log(email.match(format))

    // if (!format.test(email)) {
    //     return false;
    // }
}


// WEBPACK FOOTER //
// ./src/utils/validate.js